const Roles = {
  ROLE_SELLER: '1',
  ROLE_MANAGER: '2',
  ROLE_SUB_ADMIN: '3',
  ROLE_SUPER_ADMIN: '4'
};

Roles.install = function (Vue) {
    Vue.prototype.$getConstRole = (key) => {
        return Roles[key];
    }
}

export default Roles;
